import { Toaster as SonnerToaster } from 'sonner'

const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      visibleToasts={8}
      toastOptions={{
        className: 'sonner',
      }}
    />
  )
}

export default Toaster
